import { ExoApiError } from 'src/apis/baseQuery'
import { SerializedError } from '@reduxjs/toolkit'
import axios from 'axios'
/**
* Type predicate to narrow an unknown error to `ExoApiError`
*/
export function isExoApiError(
    error: unknown,
): error is ExoApiError {
    return typeof error === 'object' && error != null && 'status' in error && 'data' in error
}

/**
 * Detects a gateway timeout on a long-running request: either a readable 504 response
 * or a connection dropped by the gateway without a readable response
 */
export function isGatewayTimeoutError(
    error: unknown,
): boolean {
    if (isExoApiError(error)) {
        return error.status === 504
    }
    return axios.isAxiosError(error) && !error.response
}

/**
 * Type predicate to narrow an unknown error to an object with a string 'message' property
 */
export function isErrorWithMessage(
    error: unknown,
): error is SerializedError {
    return (
        typeof error === 'object' &&
        error != null &&
        'message' in error &&
        typeof (error as any).message === 'string'
    )
}